export default __webpack_public_path__ + "static/persons-feature-flag-tab-light-mode-bc825d7e24134cd27c83666e128dcefc.png";